import angular from 'angular';

export const REVENUE_PERIODS = {
    LAST_12_MONTH: 'LAST_12_MONTH',
    CURRENT_MONTH: 'CURRENT_MONTH',
    CURRENT_QUARTER: 'CURRENT_QUARTER',
    CURRENT_YEAR: 'CURRENT_YEAR',
};

angular
    .module('TALENYA-FE')
    .constant('REVENUE_PERIODS', REVENUE_PERIODS);
